import React from "react";

export default function WeUseYourInfor() {
  return (
    <>
      {/* <div className="tp-service-2-area   pb-150 z-index-5">
        <div className="container container-1480">
          <div className="row">
            <div className="col-xl-8">
              <div className="tp-service-2-title-box mb-70">
                <span className="tp-section-subtitle-3">
                  <span>
                    <svg
                      width={12}
                      height={12}
                      viewBox="0 0 12 12"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M12 0C12 3.0432 9.53292 5.5102 6.48975 5.5102C6.48975 2.46701 8.95677 0 12 0Z"
                        fill="currentcolor"
                      />
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M0.0231934 0.0231209C3.06639 0.0231209 5.5334 2.49015 5.5334 5.53333C2.4902 5.53333 0.0231934 3.0663 0.0231934 0.0231209Z"
                        fill="currentcolor"
                      />
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M6.48975 6.4898C9.53294 6.4898 12 8.95682 12 12C8.95675 12 6.48975 9.53297 6.48975 6.4898Z"
                        fill="currentcolor"
                      />
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M5.5102 6.48981C5.5102 9.533 3.04318 12 0 12C0 8.95681 2.46703 6.48981 5.5102 6.48981Z"
                        fill="currentcolor"
                      />
                    </svg>
                  </span>
                </span>
                <h4 className="tp-hero-3-title tp_reveal_anim text-yellow-new">
                  How We Use Your Information
                </h4>
              </div>
            </div>
          </div>
          <div className="row align-items-center">
            <div className="col-xxl-6 col-xl-4 col-lg-4">
              <div className="tp-service-2-shape-img text-center text-lg-start">
                <img src="assets/img/home-02/service/sv-shape-1.png" alt="" />
              </div>
            </div>
            <div className="col-xxl-6 col-xl-8 col-lg-8">
              <div className="tp-service-2-accordion-box">
                <div className="accordion" id="accordionExample">
                  <div className="accordion-items">
                    <h2 className="accordion-header">
                      <button
                        className="accordion-buttons collapsed"
                        type="button"
                        data-bs-toggle="collapse"
                        data-bs-target="#collapseOne"
                        aria-expanded="true"
                        aria-controls="collapseOne"
                      >
                        NFT Processing & Verification
                        <span className="accordion-icon" />
                      </button>
                    </h2>
                    <div
                      id="collapseOne"
                      className="accordion-collapse collapse"
                      data-bs-parent="#accordionExample"
                    >
                      <div className="accordion-body">
                        <p>
                          Ensuring smooth transaction processing and
                          authentication of NFT ownership.
                        </p>
                      </div>
                    </div>
                  </div>
                  <div className="accordion-items">
                    <h2 className="accordion-header">
                      <button
                        className="accordion-buttons collapsed"
                        type="button"
                        data-bs-toggle="collapse"
                        data-bs-target="#collapseTwo"
                        aria-expanded="false"
                        aria-controls="collapseTwo"
                      >
                        User Security & Fraud Prevention
                        <span className="accordion-icon" />
                      </button>
                    </h2>
                    <div
                      id="collapseTwo"
                      className="accordion-collapse collapse"
                      data-bs-parent="#accordionExample"
                    >
                      <div className="accordion-body">
                        <p>
                          Monitoring suspicious activities and preventing
                          unauthorized transactions.
                        </p>
                      </div>
                    </div>
                  </div>
                  <div className="accordion-items">
                    <h2 className="accordion-header">
                      <button
                        className="accordion-buttons collapsed"
                        type="button"
                        data-bs-toggle="collapse"
                        data-bs-target="#collapseThree"
                        aria-expanded="false"
                        aria-controls="collapseThree"
                      >
                        Enhancing User Experience
                        <span className="accordion-icon" />
                      </button>
                    </h2>
                    <div
                      id="collapseThree"
                      className="accordion-collapse collapse"
                      data-bs-parent="#accordionExample"
                    >
                      <div className="accordion-body">
                        <p>
                          Customizing interactions and improving our platform.
                        </p>
                      </div>
                    </div>
                  </div>
                  <div className="accordion-items">
                    <h2 className="accordion-header">
                      <button
                        className="accordion-buttons collapsed"
                        type="button"
                        data-bs-toggle="collapse"
                        data-bs-target="#collapseFour"
                        aria-expanded="false"
                        aria-controls="collapseFour"
                      >
                        Providing Customer Support
                        <span className="accordion-icon" />
                      </button>
                    </h2>
                    <div
                      id="collapseFour"
                      className="accordion-collapse collapse"
                      data-bs-parent="#accordionExample"
                    >
                      <div className="accordion-body">
                        <p>
                          Responding to user inquiries and resolving issues.
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div> */}

      <div className="tp-award-area  pt-100 pb-125">
        <div className="container container-1630">
          <div className="row">
            <div className="col-xl-12">
              <div className="tp-service-5-title-box text-center">
                <h3 className="tp-hero-3-title tp_reveal_anim ">
                  How We Use Your Information
                </h3>
              </div>
            </div>
          </div>
          <div className="row justify-content-center">
            <div className="col-xl-10 col-lg-10 col-md-12">
              <div className="tp-award-list-wrap">
                <div
                  className="tp-award-list-item d-flex align-items-center justify-content-between tp_fade_bottom"
                  rel="tp-award-list-thumb-2"
                >
                  <div className="tp-award-list-content-left  align-items-center">
                    <h5 className="pb-10 text-color-yellow">
                      NFT Processing & Verification{" "}
                    </h5>
                    <p>
                      Ensuring smooth transaction processing and authentication
                      of NFT ownership.
                    </p>
                  </div>
                </div>
                <div
                  className="tp-award-list-item d-flex align-items-center justify-content-between tp_fade_bottom"
                  rel="tp-award-list-thumb-3"
                >
                  <div className="tp-award-list-content-left  align-items-center">
                    <h5 className="pb-10 text-color-yellow">
                      User Security & Fraud Prevention
                    </h5>
                    <p>
                      Monitoring suspicious activities and preventing
                      unauthorized transactions.
                    </p>
                  </div>
                </div>
                <div
                  className="tp-award-list-item d-flex align-items-center justify-content-between tp_fade_bottom"
                  rel="tp-award-list-thumb-4"
                >
                  <div className="tp-award-list-content-left  align-items-center">
                    <h5 className="pb-10 text-color-yellow">
                      Enhancing User Experience{" "}
                    </h5>
                    <p>Customizing interactions and improving our platform.</p>
                  </div>
                </div>
                <div
                  className="tp-award-list-item d-flex align-items-center justify-content-between tp_fade_bottom"
                  rel="tp-award-list-thumb-4"
                >
                  <div className="tp-award-list-content-left  align-items-center">
                    <h5 className="pb-10 text-color-yellow">
                      Providing Customer Support
                    </h5>
                    <p>Responding to user inquiries and resolving issues.</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
